module.exports = __webpack_public_path__ + "img/china.ce0184f1.svg";